module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "explicacaoModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "explicacaoModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Entendi",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Endereço\n                "), (_vm.cadastrado.mostraMultiplosRegistros) ? _c('span', [_vm._v(_vm._s(_vm._f("formataRegistro")(_vm.cadastrado.registro)))]) : _vm._e(), _vm._v(" \n                "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cadastrado.pessoa.recebeValeTransporte),
      expression: "cadastrado.pessoa.recebeValeTransporte"
    }]
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.abreExplicacaoModal()
      }
    }
  }, [_vm._v("(Como editar meu endereço?)")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "content"
    }
  }, [(_vm.cadastrado.lancamentoPermitido) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cep"
    }
  }, [_vm._v("CEP")]), _vm._v(" "), _c('p', [_vm._v("\n                          " + _vm._s(_vm._f("formataCep")(_vm.cadastrado.pessoa.endereco.cep)) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "logradouro"
    }
  }, [_vm._v("Logradouro")]), _vm._v(" "), _c('p', [_vm._v("\n                          " + _vm._s(_vm.cadastrado.pessoa.endereco.tipoLogradouro +
    ' ' +
    _vm.cadastrado.pessoa.endereco.logradouro) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 hidden-xs"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "numero"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cadastrado.pessoa.endereco.numero))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row visible-xs-12 hidden-sm hidden-md hidden-lg"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "numero-xs"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cadastrado.pessoa.endereco.numero))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "complemento-xs"
    }
  }, [_vm._v("Complem.")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cadastrado.pessoa.endereco.complemento))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 hidden-xs"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Complemento")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cadastrado.pessoa.endereco.complemento))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Bairro")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput"
  }, [_vm._v("\n                          " + _vm._s(_vm.cadastrado.pessoa.endereco.bairro) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Município")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput"
  }, [_vm._v("\n                          " + _vm._s(_vm.cadastrado.pessoa.endereco.cidade) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "proprio"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput"
  }, [_vm._v("\n                          " + _vm._s(_vm.cadastrado.pessoa.endereco.uf) + "\n                        ")])])])])]) : _c('div', {
    staticClass: "row"
  }, [_c('pms-endereco', {
    ref: "enderecoComponente",
    attrs: {
      "api": _vm.$root.$data.apiEnderecoUrl,
      "apiUrl": _vm.$root.$data.apiUrl,
      "parentCep": _vm.cadastrado.pessoa.endereco.cep,
      "parentTipoLogradouro": _vm.cadastrado.pessoa.endereco.tipoLogradouro,
      "parentLogradouro": _vm.cadastrado.pessoa.endereco.logradouro,
      "parentBairro": _vm.cadastrado.pessoa.endereco.bairro,
      "parentMunicipio": _vm.cadastrado.pessoa.endereco.cidade,
      "parentEstado": _vm.cadastrado.pessoa.endereco.uf,
      "parentNumero": _vm.cadastrado.pessoa.endereco.numero,
      "parentComplemento": _vm.cadastrado.pessoa.endereco.complemento,
      "parentGeorreferenciado": _vm.cadastrado.pessoa.endereco.georreferenciado,
      "parentInseridoPeloUsuario": _vm.cadastrado.pessoa.endereco.inseridoPeloUsuario,
      "disabled": !_vm.enderecoEditavel
    },
    on: {
      "submitEndereco": _vm.gravaPessoaEndereco
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-esq",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Avançar",
      "icone": "avancar",
      "icone-direita": true
    },
    on: {
      "clicado": function($event) {
        return _vm.avanca('Contatos')
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "explicacaoModalLabel"
    }
  }, [_vm._v("\n              Regra de Edição de Endereço\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Para servidores com "), _c('strong', [_vm._v("vale transporte")]), _vm._v(" ativo, as alterações serão validadas pela Seção de Controle de Cestas Básicas e Vale Transporte – "), _c('strong', [_vm._v("SEVALE")]), _vm._v(".\n                ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55dc2de6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/recadastramento/endereco/index.vue
// module id = IOhd
// module chunks = 5